import { Typography } from "@mui/material";
import { ArrowRight } from "@phosphor-icons/react";
import React from "react";
import { Handle, Position } from "reactflow";
import { useHandleConnection } from "./useHandleConnection";
import { HandleId, InputHandleProps } from "./types.d";

const INPUT_VALID_SOURCES: HandleId[] = [
  HandleId.Global,
  HandleId.OutputFlow,
  HandleId.ConditionHandle,
  HandleId.OutputHandle,
];

const InputHandle = ({ index, colorActive }: InputHandleProps) => {
  const isActive = !!index;

  const {
    isDropTarget,
    isDark,
    backgroundColor,
    baseStyle,
    handleMouseEnter,
    handleMouseLeave,
  } = useHandleConnection({
    handleId: HandleId.Input,
    validSourceHandles: INPUT_VALID_SOURCES,
    isActive,
    colorActive,
    side: "left",
  });

  const inputBackgroundColor = isDropTarget
    ? colorActive?.color
    : isActive
      ? colorActive?.background
      : backgroundColor;

  return (
    <Handle
      type="target"
      position={Position.Left}
      id={HandleId.Input}
      style={{ ...baseStyle, background: inputBackgroundColor }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {isActive ? (
        <Typography
          sx={{
            color: isDark ? "#1D2939" : "#FFFFFF",
            fontSize: "16px",
            fontWeight: 700,
            pointerEvents: "none",
          }}
        >
          {index}
        </Typography>
      ) : (
        <ArrowRight
          weight="bold"
          color={isDropTarget ? "#FFFFFF" : "#667085"}
          pointerEvents="none"
          size={14}
        />
      )}
    </Handle>
  );
};

export default InputHandle;
